import { localeNumber } from 'src/localization/locale';
import React from 'react';
import classNames from 'classnames';
import styles from './Trend.module.scss';
import Icon from '../Icon/Icon';

export interface TrendProps {
  percentage: number;
  progressColor?: string;
}

const Trend: React.FC<TrendProps> = ({ percentage, progressColor }) => {
  return (
    <div>
      {percentage !== 0 && (
        <span
          className={classNames(styles.root, 'typo-text-12--bold flex items-center')}
          style={{ color: progressColor }}>
          <Icon
            name={percentage >= 0 ? 'arrowUpward' : 'arrowDownward'}
            width={16}
            height={16}
            className="pr-2 text-current"
          />
          {`${localeNumber(Math.abs(percentage), { maximumFractionDigits: 1 })}%`}
        </span>
      )}
    </div>
  );
};

export default Trend;
